const tokens = {
  dark: {
    colors: {
      neutral: {
        10: 'rgb(31,32,34)',
        13: 'rgb(39,40,42)',
        15: 'rgb(45,46,48)',
        20: 'rgb(55,56,59)',
        30: 'rgb(109,112,117)',
        45: 'rgb(133,138,144)',
        70: 'rgb(169,173,179)',
        100: 'rgb(223,224,227)',
        150: 'rgb(247,247,248)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      brand: {
        10: '#000646',
        13: '#000F5E',
        15: '#00156D',
        20: '#0A359F',
        30: '#1357D4',
        45: '#308DF6',
        70: '#81B9F9',
        100: '#CFE4FC',
        150: '#F2F8FE',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      interactive: {
        10: 'rgb(0,32,69)',
        13: 'rgb(0,39,83)',
        15: 'rgb(0,45,96)',
        20: 'rgb(0,55,116)',
        30: 'rgb(0,106,225)',
        45: 'rgb(56,139,232)',
        70: 'rgb(121,177,239)',
        100: 'rgb(206,227,249)',
        150: 'rgb(242,248,254)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      accent: {
        10: 'rgb(0,38,29)',
        13: 'rgb(0,46,36)',
        15: 'rgb(0,53,41)',
        20: 'rgb(0,65,50)',
        30: '#007F63',
        45: 'rgb(0,156,121)',
        70: 'rgb(0,196,152)',
        100: 'rgb(171,237,223)',
        150: 'rgb(234,251,247)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      tertiary: {
        10: 'rgb(38,25,63)',
        13: 'rgb(47,31,77)',
        15: 'rgb(54,36,89)',
        20: 'rgb(66,43,108)',
        30: 'rgb(132,87,217)',
        45: 'rgb(154,118,224)',
        70: 'rgb(186,160,234)',
        100: 'rgb(230,220,247)',
        150: 'rgb(248,246,253)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      danger: {
        10: 'rgb(66,13,0)',
        13: 'rgb(80,16,0)',
        15: 'rgb(92,19,0)',
        20: 'rgb(111,22,0)',
        30: 'rgb(215,43,0)',
        45: 'rgb(231,93,58)',
        70: 'rgb(239,149,127)',
        100: 'rgb(249,218,210)',
        150: 'rgb(254,245,243)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      warning: {
        10: 'rgb(40,32,0)',
        13: 'rgb(49,39,0)',
        15: 'rgb(56,45,0)',
        20: 'rgb(69,55,0)',
        30: 'rgb(136,109,0)',
        45: 'rgb(167,134,0)',
        70: 'rgb(210,168,0)',
        100: 'rgb(255,204,0)',
        150: 'rgb(255,247,217)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      success: {
        10: 'rgb(0,39,0)',
        13: 'rgb(0,48,0)',
        15: 'rgb(0,55,0)',
        20: 'rgb(0,67,0)',
        30: 'rgb(0,131,0)',
        45: 'rgb(43,158,43)',
        70: 'rgb(113,190,113)',
        100: 'rgb(204,232,204)',
        150: 'rgb(242,249,242)',
        zero: 'rgb(0,0,0)',
        max: 'rgb(255,255,255)',
      },
      accessory: {
        1: {
          10: '#1C1386',
          13: 'rgb(50,32,65)',
          15: '#4D31BA',
          20: '#8457D9',
          30: '#B473E9',
          45: '#D490F1',
          70: '#F1AEF3',
          100: '#FDD1F6',
          150: 'rgb(250,245,254)',
          zero: 'rgb(0,0,0)',
          max: 'rgb(255,255,255)',
        },
        2: {
          10: '#192887',
          13: 'rgb(2,42,71)',
          15: '#1C4EB4',
          20: '#0781DA',
          30: '#17A6F8',
          45: '#2FC7F0',
          70: '#64E4E8',
          100: '#A6F6E0',
          150: 'rgb(241,248,253)',
          zero: 'rgb(0,0,0)',
          max: 'rgb(255,255,255)',
        },
        3: {
          10: '#02516C',
          13: 'rgb(1,46,41)',
          15: '#047885',
          20: '#059A9A',
          30: '#05BAA5',
          45: '#07D7A8',
          70: '#77E9A1',
          100: '#B7F4AC',
          150: 'rgb(236,250,248)',
          zero: 'rgb(0,0,0)',
          max: 'rgb(255,255,255)',
        },
        4: {
          10: '#790C03',
          13: 'rgb(72,25,5)',
          15: '#B22205',
          20: '#DF4E0F',
          30: '#FF7830',
          45: '#FFAB00',
          70: '#FFCC66',
          100: '#FFE982',
          150: 'rgb(253,246,242)',
          zero: 'rgb(0,0,0)',
          max: 'rgb(255,255,255)',
        },
        5: {
          10: '#5D074A',
          13: 'rgb(73,21,41)',
          15: '#891150',
          20: '#C2386C',
          30: '#F05887',
          45: '#FF8888',
          70: '#FFB2A3',
          100: '#FFCCA1',
          150: 'rgb(252,245,248)',
          zero: 'rgb(0,0,0)',
          max: 'rgb(255,255,255)',
        },
      },
    },
    backgroundColor: {
      base: 'rgb(0,0,0)',
      active: 'rgb(45,46,48)',
      focus: 'rgb(31,32,34)',
      hover: 'rgb(31,32,34)',
      surface: 'rgb(31,32,34)',
      disabled: 'rgb(0,0,0)',
      neutral: {
        base: 'rgb(0,0,0)',
        active: 'rgb(109,112,117)',
        focus: 'rgb(31,32,34)',
        hover: 'rgb(109,112,117)',
        surface: 'rgb(247,247,248)',
        disabled: 'rgb(31,32,34)',
        fill: {
          base: 'rgb(133,138,144)',
          hover: 'rgb(223,224,227)',
          active: 'rgb(223,224,227)',
          focus: 'rgb(109,112,117)',
          surface: 'rgb(255,255,255)',
          disabled: 'rgb(45,46,48)',
        },
      },
      interactive: {
        base: 'rgb(0,0,0)',
        active: 'rgb(0,45,96)',
        focus: 'rgb(0,32,69)',
        hover: 'rgb(0,32,69)',
        surface: 'rgb(0,39,83)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: 'rgb(56,139,232)',
          hover: 'rgb(121,177,239)',
          active: 'rgb(206,227,249)',
          focus: 'rgb(121,177,239)',
          surface: 'rgb(0,45,96)',
          disabled: 'rgb(56,139,232)',
        },
      },
      brand: {
        base: 'rgb(0,0,0)',
        active: '#00156D',
        focus: '#000646',
        hover: '#000646',
        surface: '#000646',
        disabled: 'rgb(45,46,48)',
        fill: {
          base: '#308DF6',
          hover: '#81B9F9',
          active: '#CFE4FC',
          focus: '#1357D4',
          surface: '#000646',
          disabled: 'rgb(45,46,48)',
        },
      },
      accent: {
        base: 'rgb(0,0,0)',
        active: 'rgb(0,53,41)',
        focus: 'rgb(0,38,29)',
        hover: 'rgb(0,38,29)',
        surface: 'rgb(0,46,36)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: '#007F63',
          active: 'rgb(0,196,152)',
          focus: 'rgb(0,156,121)',
          hover: 'rgb(0,156,121)',
          surface: 'rgb(0,53,41)',
          disabled: '#007F63',
        },
      },
      tertiary: {
        base: 'rgb(0,0,0)',
        active: 'rgb(54,36,89)',
        focus: 'rgb(38,25,63)',
        hover: 'rgb(38,25,63)',
        surface: 'rgb(47,31,77)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: 'rgb(154,118,224)',
          active: 'rgb(230,220,247)',
          focus: 'rgb(186,160,234)',
          hover: 'rgb(186,160,234)',
          surface: 'rgb(54,36,89)',
          disabled: 'rgb(154,118,224)',
        },
      },
      danger: {
        base: 'rgb(0,0,0)',
        active: 'rgb(92,19,0)',
        focus: 'rgb(66,13,0)',
        hover: 'rgb(66,13,0)',
        surface: 'rgb(80,16,0)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: 'rgb(231,93,58)',
          active: 'rgb(249,218,210)',
          focus: 'rgb(239,149,127)',
          hover: 'rgb(239,149,127)',
          surface: 'rgb(92,19,0)',
          disabled: 'rgb(231,93,58)',
        },
      },
      warning: {
        base: 'rgb(0,0,0)',
        active: 'rgb(56,45,0)',
        focus: 'rgb(40,32,0)',
        hover: 'rgb(40,32,0)',
        surface: 'rgb(40,32,0)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: 'rgb(56,45,0)',
          active: 'rgb(167,134,0)',
          focus: 'rgb(136,109,0)',
          hover: 'rgb(136,109,0)',
          surface: 'rgb(49,39,0)',
          disabled: 'rgb(56,45,0)',
        },
      },
      success: {
        base: 'rgb(0,0,0)',
        active: 'rgb(0,55,0)',
        focus: 'rgb(0,39,0)',
        hover: 'rgb(0,39,0)',
        surface: 'rgb(0,48,0)',
        disabled: 'rgb(0,0,0)',
        fill: {
          base: 'rgb(43,158,43)',
          active: 'rgb(204,232,204)',
          focus: 'rgb(113,190,113)',
          hover: 'rgb(113,190,113)',
          surface: 'rgb(0,55,0)',
          disabled: 'rgb(133,138,144)',
        },
      },
      fillNeutral: {
        base: 'rgb(133,138,144)',
        hover: 'rgb(169,173,179)',
        active: 'rgb(223,224,227)',
        focus: 'rgb(169,173,179)',
        disabled: 'rgb(133,138,144)',
        surface: 'rgb(247,247,248)',
      },
      clickHardNeutral: {
        base: 'rgb(0,0,0)',
        hover: 'rgb(247,247,248)',
        active: 'rgb(247,247,248)',
        focus: 'rgb(247,247,248)',
        disabled: 'rgb(0,0,0)',
        surface: 'rgb(109,112,117)',
      },
      clickNeutral: {
        base: 'rgb(0,0,0)',
        hover: 'rgb(45,46,48)',
        active: 'rgb(109,112,117)',
        focus: 'rgb(45,46,48)',
        disabled: 'rgb(0,0,0)',
        surface: 'rgb(39,40,42)',
      },
      clickSoft: {
        base: 'rgb(0,0,0)',
        hover: '#000646',
        active: '#00156D',
        focus: '#000646',
        disabled: 'rgb(0,0,0)',
        surface: '#00156D',
      },
      clickHard: {
        base: 'rgb(0,0,0)',
        hover: '#308DF6',
        active: '#81B9F9',
        focus: '#308DF6',
        disabled: 'rgb(0,0,0)',
      },
      click: {
        base: '#308DF6',
        hover: '#81B9F9',
        active: '#CFE4FC',
        focus: '#81B9F9',
        disabled: '#308DF6',
      },
      brandFill: {
        base: '#000646',
        hover: '#000F5E',
        active: '#00156D',
        focus: '#000F5E',
        disabled: '#000646',
        surface: '#000F5E',
      },
      select: {
        base: 'rgb(0,0,0)',
        hover: '#308DF6',
        active: '#308DF6',
        focus: '#308DF6',
        disabled: 'rgb(0,0,0)',
      },
      selectTactile: {
        base: 'rgb(0,0,0)',
        hover: '#000646',
        active: '#308DF6',
        focus: '#000646',
        disabled: 'rgb(0,0,0)',
      },
      selectToggle: {
        base: 'rgb(0,0,0)',
        hover: 'rgb(0,0,0)',
        active: '#308DF6',
        focus: 'rgb(0,0,0)',
        disabled: 'rgb(0,0,0)',
      },
      selectList: {
        base: 'rgb(0,0,0)',
        hover: 'rgb(45,46,48)',
        active: '#000F5E',
        focus: 'rgb(45,46,48)',
        disabled: 'rgb(0,0,0)',
      },
    },
    borderColor: {
      base: 'rgb(109,112,117)',
      soft: 'rgb(45,46,48)',
      active: 'rgb(109,112,117)',
      focus: 'rgb(109,112,117)',
      hover: 'rgb(56,139,232)',
      disabled: 'rgb(45,46,48)',
      neutral: {
        base: 'rgb(223,224,227)',
        active: 'rgb(223,224,227)',
        focus: 'rgb(56,139,232)',
        hover: 'rgb(255,255,255)',
        disabled: 'rgb(45,46,48)',
        fill: {
          base: 'rgb(0,0,0)',
          active: 'rgb(0,0,0)',
          focus: 'rgb(0,0,0)',
          hover: 'rgb(0,0,0)',
          disabled: 'rgb(0,0,0)',
          surface: 'rgb(255,255,255)',
        },
      },
      interactive: {
        base: 'rgb(56,139,232)',
        active: 'rgb(206,227,249)',
        focus: 'rgb(0,106,225)',
        hover: 'rgb(121,177,239)',
        disabled: 'rgb(45,46,48)',
      },
      brand: {
        base: '#308DF6',
        active: '#CFE4FC',
        focus: '#1357D4',
        hover: '#81B9F9',
        disabled: 'rgb(45,46,48)',
      },
      accent: {
        base: 'rgb(0,156,121)',
        active: 'rgb(171,237,223)',
        focus: '#007F63',
        hover: 'rgb(0,196,152)',
        disabled: 'rgb(45,46,48)',
      },
      tertiary: {
        base: 'rgb(154,118,224)',
        active: 'rgb(230,220,247)',
        focus: 'rgb(132,87,217)',
        hover: 'rgb(186,160,234)',
        disabled: 'rgb(45,46,48)',
      },
      danger: {
        base: 'rgb(231,93,58)',
        active: 'rgb(249,218,210)',
        focus: 'rgb(215,43,0)',
        hover: 'rgb(239,149,127)',
        disabled: 'rgb(45,46,48)',
      },
      success: {
        base: 'rgb(43,158,43)',
        active: 'rgb(204,232,204)',
        focus: 'rgb(0,131,0)',
        hover: 'rgb(113,190,113)',
        disabled: 'rgb(45,46,48)',
      },
      warning: {
        base: 'rgb(255,204,0)',
        active: 'rgb(255,255,255)',
        focus: 'rgb(136,109,0)',
        hover: 'rgb(255,247,217)',
        disabled: 'rgb(45,46,48)',
      },
    },
    depth: {
      boxShadow: {
        0: {
          xOffset: '0px',
          yOffset: '0px',
          blurRadius: '0px',
          spreadRadius: '0px',
          color: 'rgba(0, 0, 0, 0.0)',
        },
        1: {
          xOffset: '0px',
          yOffset: '0px',
          blurRadius: '12px',
          spreadRadius: '2px',
          color: 'rgba(0, 0, 0, 0.10)',
        },
        2: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '16px',
          spreadRadius: '-4px',
          color: 'rgba(0, 0, 0, 0.10)',
        },
        3: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '20px',
          spreadRadius: '0px',
          color: 'rgba(0, 0, 0, 0.20)',
        },
        4: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '20px',
          spreadRadius: '-2px',
          color: 'rgba(0, 0, 0, 0.25)',
        },
        soft: {
          xOffset: '0rem',
          yOffset: '0.5rem',
          blurRadius: '1.25rem',
          spreadRadius: '0rem',
          color: 'rgba(0, 0, 0, 0.06)',
        },
        hard: {
          xOffset: '0rem',
          yOffset: '0.25rem',
          blurRadius: '0.5rem',
          spreadRadius: '-0.125rem',
          color: 'rgba(0, 0, 0, 0.25)',
        },
      },
      opacity: {
        transparent: 0,
        min: 0.3,
        light: 0.4,
        medium: 0.5,
        heavy: 0.8,
        max: 0.9,
        opaque: 1,
      },
      zIndex: { 100: 100, 400: 400, 800: 800, 1600: 1600 },
    },
    icon: { size: { s: '0.875rem', m: '1rem', l: '1.5rem', xl: '2rem' } },
    size: {
      border: {
        base: 1,
        focus: 2,
        active: 4,
        disabled: 1,
        radius: { twoX: '4px', threeX: '6px', fiveX: '10px', round: '100px' },
      },
    },
    transition: { duration: { default: '.3s' } },
    font: {
      color: {
        base: 'rgb(247,247,248)',
        soft: 'rgb(133,138,144)',
        fill: 'rgb(0,0,0)',
        active: 'rgb(223,224,227)',
        focus: 'rgb(223,224,227)',
        hover: 'rgb(223,224,227)',
        disabled: 'rgb(109,112,117)',
        onLight: 'rgb(247,247,248)',
        onDark: 'rgb(0,0,0)',
        neutral: {
          base: 'rgb(133,138,144)',
          fill: 'rgb(45,46,48)',
          active: 'rgb(223,224,227)',
          focus: 'rgb(109,112,117)',
          hover: 'rgb(169,173,179)',
          disabled: 'rgb(109,112,117)',
        },
        interactive: {
          base: 'rgb(56,139,232)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(206,227,249)',
          focus: 'rgb(0,106,225)',
          hover: 'rgb(121,177,239)',
          disabled: 'rgb(109,112,117)',
        },
        brand: {
          base: '#308DF6',
          fill: 'rgb(0,0,0)',
          active: '#CFE4FC',
          focus: '#1357D4',
          hover: '#81B9F9',
          disabled: 'rgb(109,112,117)',
        },
        accent: {
          base: 'rgb(0,156,121)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(171,237,223)',
          focus: '#007F63',
          hover: 'rgb(0,196,152)',
          disabled: 'rgb(109,112,117)',
        },
        tertiary: {
          base: 'rgb(154,118,224)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(230,220,247)',
          focus: 'rgb(132,87,217)',
          hover: 'rgb(186,160,234)',
          disabled: 'rgb(109,112,117)',
        },
        danger: {
          base: 'rgb(231,93,58)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(249,218,210)',
          focus: 'rgb(215,43,0)',
          hover: 'rgb(239,149,127)',
          disabled: 'rgb(109,112,117)',
        },
        success: {
          base: 'rgb(43,158,43)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(204,232,204)',
          focus: 'rgb(0,131,0)',
          hover: 'rgb(113,190,113)',
          disabled: 'rgb(109,112,117)',
        },
        warning: {
          base: 'rgb(255,204,0)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(255,204,0)',
          focus: 'rgb(255,204,0)',
          hover: 'rgb(255,204,0)',
          disabled: 'rgb(109,112,117)',
        },
      },
      lineHeight: { heading: '1.25', prose: '1.6', list: '1.25', base: '1.5' },
      base: {
        family: "'Rubik', 'Helvetica', 'Arial'",
        weight: { light: 300, regular: 400, bold: 500 },
        size: {
          0: '0.625rem',
          1: '0.75rem',
          2: '0.8125rem',
          3: '0.875rem',
          4: '1rem',
          5: '1.125rem',
          6: '1.25rem',
          7: '1.5rem',
          8: '1.875rem',
          9: '2.25rem',
          10: '3rem',
          h1: '2.25rem',
          h2: '1.5rem',
          h3: '1.3125rem',
          h4: '1.125rem',
          h5: '0.875rem',
          h6: '0.75rem',
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
      prose: {
        family: "'Open Sans', 'Rubik', 'Helvetica', 'Arial', sans-serif",
        weight: { light: 400, regular: 400, bold: 700 },
        size: {
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
      mono: {
        family: "'Roboto Mono', monospace",
        weight: { light: 400, regular: 400, bold: 400 },
        size: {
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
    },
    animation: {
      expressive: {
        easeOut: {
          easing: 'cubic-bezier(0, 0, 0.39, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeIn: {
          easing: 'cubic-bezier(0.4, 0.14, 1, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeInOut: {
          easing: 'cubic-bezier(0.4, 0.15, 0.3, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
      },
      productive: {
        easeOut: {
          easing: 'cubic-bezier(0, 0, 0.4, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeIn: {
          easing: 'cubic-bezier(0.2, 0, 1, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeInOut: {
          easing: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
      },
      linear: {
        easing: 'cubic-bezier(0,0,1,1)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700,
        },
      },
      delay: { fastest: 100, fast: 200, medium: 400, slow: 550, slowest: 700 },
      transition: { duration: { default: '.3s' } },
      transform: { shrink: 'scale(0.96)', grow: 'scale(1.04)' },
    },
  },
  default: {
    colors: {
      neutral: {
        10: 'rgb(247,248,249)',
        13: 'rgb(236,237,239)',
        15: 'rgb(217,220,222)',
        20: 'rgb(166,171,177)',
        30: 'rgb(154, 159, 166)',
        45: 'rgb(105,113,122)',
        70: 'rgb(74,80,89)',
        100: 'rgb(52,56,63)',
        150: 'rgb(26,32,38)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      brand: {
        10: 'rgb(242,248,254)',
        13: 'rgb(227,239,252)',
        15: '#CFE4FC',
        20: 'rgb(117,174,239)',
        30: '#4494EF',
        45: '#006DE9',
        70: '#004CD6',
        100: '#0025BD',
        150: '#010D8E',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      interactive: {
        10: 'rgb(242,248,254)',
        13: 'rgb(227,239,252)',
        15: 'rgb(211,229,250)',
        20: 'rgb(117,174,239)',
        30: 'rgb(66,145,233)',
        45: 'rgb(0,106,225)',
        70: 'rgb(0,80,171)',
        100: 'rgb(0,54,115)',
        150: 'rgb(0,33,70)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      accent: {
        10: 'rgb(234,251,247)',
        13: 'rgb(208,245,237)',
        15: 'rgb(179,239,226)',
        20: 'rgb(0,193,150)',
        30: '#00ca9d',
        45: 'rgb(0,130,101)',
        70: 'rgb(0,95,74)',
        100: 'rgb(0,64,50)',
        150: 'rgb(0,39,30)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      tertiary: {
        10: 'rgb(248,246,253)',
        13: 'rgb(240,235,250)',
        15: 'rgb(232,223,248)',
        20: 'rgb(184,157,233)',
        30: 'rgb(159,124,225)',
        45: 'rgb(132,87,217)',
        70: 'rgb(97,64,160)',
        100: 'rgb(65,43,107)',
        150: 'rgb(39,26,64)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      danger: {
        10: 'rgb(254,245,243)',
        13: 'rgb(252,234,229)',
        15: 'rgb(250,221,214)',
        20: 'rgb(239,146,123)',
        30: 'rgb(232,102,69)',
        45: 'rgb(219,44,0)',
        70: 'rgb(162,33,0)',
        100: 'rgb(110,22,0)',
        150: 'rgb(68,14,0)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      warning: {
        10: 'rgb(255,247,217)',
        13: 'rgb(255,237,167)',
        15: 'rgb(255,204,0)',
        20: 'rgb(207,165,0)',
        30: 'rgb(173,138,0)',
        45: 'rgb(139,111,0)',
        70: 'rgb(102,81,0)',
        100: 'rgb(68,54,0)',
        150: 'rgb(41,32,0)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      success: {
        10: 'rgb(242,249,242)',
        13: 'rgb(226,242,226)',
        15: 'rgb(209,234,209)',
        20: 'rgb(109,188,109)',
        30: 'rgb(54,163,54)',
        45: 'rgb(0,134,0)',
        70: 'rgb(0,98,0)',
        100: 'rgb(0,66,0)',
        150: 'rgb(0,40,0)',
        zero: 'rgb(255,255,255)',
        max: 'rgb(0,0,0)',
      },
      accessory: {
        1: {
          10: '#FDD1F6',
          13: 'rgb(244,234,252)',
          15: '#F1AEF3',
          20: '#D490F1',
          30: '#B473E9',
          45: '#8457D9',
          70: '#4D31BA',
          100: '#1C1386',
          150: 'rgb(42,27,54)',
          zero: 'rgb(255,255,255)',
          max: 'rgb(0,0,0)',
        },
        2: {
          10: '#A6F6E0',
          13: 'rgb(225,240,250)',
          15: '#64E4E8',
          20: '#2FC7F0',
          30: '#17A6F8',
          45: '#0781DA',
          70: '#1C4EB4',
          100: '#192887',
          150: 'rgb(2,35,59)',
          zero: 'rgb(255,255,255)',
          max: 'rgb(0,0,0)',
        },
        3: {
          10: '#B7F4AC',
          13: 'rgb(213,244,240)',
          15: '#77E9A1',
          20: '#07D7A8',
          30: '#05BAA5',
          45: '#059A9A',
          70: '#047885',
          100: '#02516C',
          150: 'rgb(1,38,34)',
          zero: 'rgb(255,255,255)',
          max: 'rgb(0,0,0)',
        },
        4: {
          10: '#FFE982',
          13: 'rgb(251,234,227)',
          15: '#FFCC66',
          20: '#FFAB00',
          30: '#FF7830',
          45: '#DF4E0F',
          70: '#B22205',
          100: '#790C03',
          150: 'rgb(60,21,4)',
          zero: 'rgb(255,255,255)',
          max: 'rgb(0,0,0)',
        },
        5: {
          10: '#FFCCA1',
          13: 'rgb(248,234,239)',
          15: '#FFB2A3',
          20: '#FF8888',
          30: '#F05887',
          45: '#C2386C',
          70: '#891150',
          100: '#5D074A',
          150: 'rgb(61,18,34)',
          zero: 'rgb(255,255,255)',
          max: 'rgb(0,0,0)',
        },
      },
    },
    backgroundColor: {
      base: 'rgb(255,255,255)',
      active: 'rgb(217,220,222)',
      focus: 'rgb(247,248,249)',
      hover: 'rgb(247,248,249)',
      surface: 'rgb(247,248,249)',
      disabled: 'rgb(255,255,255)',
      neutral: {
        base: 'rgb(255,255,255)',
        active: 'rgb(154, 159, 166)',
        focus: 'rgb(247,248,249)',
        hover: 'rgb(154, 159, 166)',
        surface: 'rgb(26,32,38)',
        disabled: 'rgb(247,248,249)',
        fill: {
          base: 'rgb(105,113,122)',
          hover: 'rgb(52,56,63)',
          active: 'rgb(52,56,63)',
          focus: 'rgb(154, 159, 166)',
          surface: 'rgb(74,80,89)',
          disabled: 'rgb(217,220,222)',
        },
      },
      interactive: {
        base: 'rgb(255,255,255)',
        active: 'rgb(211,229,250)',
        focus: 'rgb(242,248,254)',
        hover: 'rgb(242,248,254)',
        surface: 'rgb(227,239,252)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: 'rgb(0,106,225)',
          hover: 'rgb(0,80,171)',
          active: 'rgb(0,54,115)',
          focus: 'rgb(0,80,171)',
          surface: 'rgb(211,229,250)',
          disabled: 'rgb(0,106,225)',
        },
      },
      brand: {
        base: 'rgb(255,255,255)',
        active: '#CFE4FC',
        focus: 'rgb(242,248,254)',
        hover: 'rgb(242,248,254)',
        surface: 'rgb(242,248,254)',
        disabled: 'rgb(217,220,222)',
        fill: {
          base: '#006DE9',
          hover: '#004CD6',
          active: '#0025BD',
          focus: '#4494EF',
          surface: 'rgb(242,248,254)',
          disabled: 'rgb(217,220,222)',
        },
      },
      accent: {
        base: 'rgb(255,255,255)',
        active: 'rgb(179,239,226)',
        focus: 'rgb(234,251,247)',
        hover: 'rgb(234,251,247)',
        surface: 'rgb(208,245,237)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: '#00ca9d',
          active: 'rgb(0,95,74)',
          focus: 'rgb(0,130,101)',
          hover: 'rgb(0,130,101)',
          surface: 'rgb(179,239,226)',
          disabled: '#00ca9d',
        },
      },
      tertiary: {
        base: 'rgb(255,255,255)',
        active: 'rgb(232,223,248)',
        focus: 'rgb(248,246,253)',
        hover: 'rgb(248,246,253)',
        surface: 'rgb(240,235,250)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: 'rgb(132,87,217)',
          active: 'rgb(65,43,107)',
          focus: 'rgb(97,64,160)',
          hover: 'rgb(97,64,160)',
          surface: 'rgb(232,223,248)',
          disabled: 'rgb(132,87,217)',
        },
      },
      danger: {
        base: 'rgb(255,255,255)',
        active: 'rgb(250,221,214)',
        focus: 'rgb(254,245,243)',
        hover: 'rgb(254,245,243)',
        surface: 'rgb(252,234,229)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: 'rgb(219,44,0)',
          active: 'rgb(110,22,0)',
          focus: 'rgb(162,33,0)',
          hover: 'rgb(162,33,0)',
          surface: 'rgb(232,102,69)',
          disabled: 'rgb(217,220,222)',
        },
      },
      warning: {
        base: 'rgb(255,255,255)',
        active: 'rgb(255,204,0)',
        focus: 'rgb(255,247,217)',
        hover: 'rgb(255,247,217)',
        surface: 'rgb(255,247,217)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: 'rgb(255,204,0)',
          active: 'rgb(139,111,0)',
          focus: 'rgb(173,138,0)',
          hover: 'rgb(173,138,0)',
          surface: 'rgb(255,237,167)',
          disabled: 'rgb(255,204,0)',
        },
      },
      success: {
        base: 'rgb(255,255,255)',
        active: 'rgb(209,234,209)',
        focus: 'rgb(242,249,242)',
        hover: 'rgb(242,249,242)',
        surface: 'rgb(226,242,226)',
        disabled: 'rgb(255,255,255)',
        fill: {
          base: 'rgb(0,134,0)',
          active: 'rgb(0,66,0)',
          focus: 'rgb(0,98,0)',
          hover: 'rgb(0,98,0)',
          surface: 'rgb(209,234,209)',
          disabled: 'rgb(105,113,122)',
        },
      },
      fillNeutral: {
        base: 'rgb(105,113,122)',
        hover: 'rgb(74,80,89)',
        active: 'rgb(52,56,63)',
        focus: 'rgb(74,80,89)',
        disabled: 'rgb(105,113,122)',
        surface: 'rgb(26,32,38)',
      },
      clickHardNeutral: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(26,32,38)',
        active: 'rgb(26,32,38)',
        focus: 'rgb(26,32,38)',
        disabled: 'rgb(255,255,255)',
        surface: 'rgb(154, 159, 166)',
      },
      clickNeutral: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(217,220,222)',
        active: 'rgb(154, 159, 166)',
        focus: 'rgb(217,220,222)',
        disabled: 'rgb(255,255,255)',
        surface: 'rgb(236,237,239)',
      },
      clickSoft: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(242,248,254)',
        active: '#CFE4FC',
        focus: 'rgb(242,248,254)',
        disabled: 'rgb(255,255,255)',
        surface: '#CFE4FC',
      },
      clickHard: {
        base: 'rgb(255,255,255)',
        hover: '#006DE9',
        active: '#004CD6',
        focus: '#006DE9',
        disabled: 'rgb(255,255,255)',
      },
      click: {
        base: '#006DE9',
        hover: '#004CD6',
        active: '#0025BD',
        focus: '#004CD6',
        disabled: '#006DE9',
      },
      brandFill: {
        base: 'rgb(242,248,254)',
        hover: 'rgb(227,239,252)',
        active: '#CFE4FC',
        focus: 'rgb(227,239,252)',
        disabled: 'rgb(242,248,254)',
        surface: 'rgb(227,239,252)',
      },
      select: {
        base: 'rgb(255,255,255)',
        hover: '#006DE9',
        active: '#006DE9',
        focus: '#006DE9',
        disabled: 'rgb(255,255,255)',
      },
      selectTactile: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(242,248,254)',
        active: '#006DE9',
        focus: 'rgb(242,248,254)',
        disabled: 'rgb(255,255,255)',
      },
      selectToggle: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(255,255,255)',
        active: '#006DE9',
        focus: 'rgb(255,255,255)',
        disabled: 'rgb(255,255,255)',
      },
      selectList: {
        base: 'rgb(255,255,255)',
        hover: 'rgb(217,220,222)',
        active: 'rgb(227,239,252)',
        focus: 'rgb(217,220,222)',
        disabled: 'rgb(255,255,255)',
      },
    },
    borderColor: {
      base: 'rgb(154, 159, 166)',
      soft: 'rgb(217,220,222)',
      active: 'rgb(154, 159, 166)',
      focus: 'rgb(154, 159, 166)',
      hover: 'rgb(0,106,225)',
      disabled: 'rgb(217,220,222)',
      neutral: {
        base: 'rgb(52,56,63)',
        active: 'rgb(52,56,63)',
        focus: 'rgb(0,106,225)',
        hover: 'rgb(74,80,89)',
        disabled: 'rgb(217,220,222)',
        fill: {
          base: 'rgb(255,255,255)',
          active: 'rgb(255,255,255)',
          focus: 'rgb(255,255,255)',
          hover: 'rgb(255,255,255)',
          disabled: 'rgb(255,255,255)',
          surface: 'rgb(74,80,89)',
        },
      },
      interactive: {
        base: 'rgb(0,106,225)',
        active: 'rgb(0,54,115)',
        focus: 'rgb(66,145,233)',
        hover: 'rgb(0,80,171)',
        disabled: 'rgb(217,220,222)',
      },
      brand: {
        base: '#006DE9',
        active: '#0025BD',
        focus: '#4494EF',
        hover: '#004CD6',
        disabled: 'rgb(217,220,222)',
      },
      accent: {
        base: 'rgb(0,130,101)',
        active: 'rgb(0,64,50)',
        focus: '#00ca9d',
        hover: 'rgb(0,95,74)',
        disabled: 'rgb(217,220,222)',
      },
      tertiary: {
        base: 'rgb(132,87,217)',
        active: 'rgb(65,43,107)',
        focus: 'rgb(159,124,225)',
        hover: 'rgb(97,64,160)',
        disabled: 'rgb(217,220,222)',
      },
      danger: {
        base: 'rgb(219,44,0)',
        active: 'rgb(110,22,0)',
        focus: 'rgb(232,102,69)',
        hover: 'rgb(162,33,0)',
        disabled: 'rgb(217,220,222)',
      },
      success: {
        base: 'rgb(0,134,0)',
        active: 'rgb(0,66,0)',
        focus: 'rgb(54,163,54)',
        hover: 'rgb(0,98,0)',
        disabled: 'rgb(217,220,222)',
      },
      warning: {
        base: 'rgb(255,204,0)',
        active: 'rgb(255,255,255)',
        focus: 'rgb(173,138,0)',
        hover: 'rgb(255,247,217)',
        disabled: 'rgb(217,220,222)',
      },
    },
    depth: {
      boxShadow: {
        0: {
          xOffset: '0px',
          yOffset: '0px',
          blurRadius: '0px',
          spreadRadius: '0px',
          color: 'rgba(0, 0, 0, 0.0)',
        },
        1: {
          xOffset: '0px',
          yOffset: '0px',
          blurRadius: '12px',
          spreadRadius: '2px',
          color: 'rgba(0, 0, 0, 0.10)',
        },
        2: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '16px',
          spreadRadius: '-4px',
          color: 'rgba(0, 0, 0, 0.10)',
        },
        3: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '20px',
          spreadRadius: '0px',
          color: 'rgba(0, 0, 0, 0.20)',
        },
        4: {
          xOffset: '0px',
          yOffset: '4px',
          blurRadius: '20px',
          spreadRadius: '-2px',
          color: 'rgba(0, 0, 0, 0.25)',
        },
        soft: {
          xOffset: '0rem',
          yOffset: '0.5rem',
          blurRadius: '1.25rem',
          spreadRadius: '0rem',
          color: 'rgba(0, 0, 0, 0.06)',
        },
        hard: {
          xOffset: '0rem',
          yOffset: '0.25rem',
          blurRadius: '0.5rem',
          spreadRadius: '-0.125rem',
          color: 'rgba(0, 0, 0, 0.25)',
        },
      },
      opacity: {
        transparent: 0,
        min: 0.3,
        light: 0.4,
        medium: 0.5,
        heavy: 0.8,
        max: 0.9,
        opaque: 1,
      },
      zIndex: { 100: 100, 400: 400, 800: 800, 1600: 1600 },
    },
    icon: { size: { s: '0.875rem', m: '1rem', l: '1.5rem', xl: '2rem' } },
    size: {
      border: {
        base: 1,
        focus: 2,
        active: 4,
        disabled: 1,
        radius: { twoX: '4px', threeX: '6px', fiveX: '10px', round: '100px' },
      },
    },
    transition: { duration: { default: '.3s' } },
    font: {
      color: {
        base: 'rgb(26,32,38)',
        soft: 'rgb(105,113,122)',
        fill: 'rgb(255,255,255)',
        active: 'rgb(52,56,63)',
        focus: 'rgb(52,56,63)',
        hover: 'rgb(52,56,63)',
        disabled: 'rgb(154, 159, 166)',
        onLight: 'rgb(26,32,38)',
        onDark: 'rgb(255,255,255)',
        neutral: {
          base: 'rgb(105,113,122)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(52,56,63)',
          focus: 'rgb(154, 159, 166)',
          hover: 'rgb(74,80,89)',
          disabled: 'rgb(154, 159, 166)',
        },
        interactive: {
          base: 'rgb(0,106,225)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(0,54,115)',
          focus: 'rgb(66,145,233)',
          hover: 'rgb(0,80,171)',
          disabled: 'rgb(154, 159, 166)',
        },
        brand: {
          base: '#006DE9',
          fill: 'rgb(255,255,255)',
          active: '#0025BD',
          focus: '#4494EF',
          hover: '#004CD6',
          disabled: 'rgb(154, 159, 166)',
        },
        accent: {
          base: 'rgb(0,130,101)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(0,64,50)',
          focus: '#00ca9d',
          hover: 'rgb(0,95,74)',
          disabled: 'rgb(154, 159, 166)',
        },
        tertiary: {
          base: 'rgb(132,87,217)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(65,43,107)',
          focus: 'rgb(159,124,225)',
          hover: 'rgb(97,64,160)',
          disabled: 'rgb(154, 159, 166)',
        },
        danger: {
          base: 'rgb(219,44,0)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(110,22,0)',
          focus: 'rgb(232,102,69)',
          hover: 'rgb(162,33,0)',
          disabled: 'rgb(154, 159, 166)',
        },
        success: {
          base: 'rgb(0,134,0)',
          fill: 'rgb(255,255,255)',
          active: 'rgb(0,66,0)',
          focus: 'rgb(54,163,54)',
          hover: 'rgb(0,98,0)',
          disabled: 'rgb(154, 159, 166)',
        },
        warning: {
          base: 'rgb(0,0,0)',
          fill: 'rgb(0,0,0)',
          active: 'rgb(0,0,0)',
          focus: 'rgb(0,0,0)',
          hover: 'rgb(0,0,0)',
          disabled: 'rgb(154, 159, 166)',
        },
      },
      lineHeight: { heading: '1.25', prose: '1.6', list: '1.25', base: '1.5' },
      base: {
        family: "'Rubik', 'Helvetica', 'Arial'",
        weight: { light: 300, regular: 400, bold: 500 },
        size: {
          0: '0.625rem',
          1: '0.75rem',
          2: '0.8125rem',
          3: '0.875rem',
          4: '1rem',
          5: '1.125rem',
          6: '1.25rem',
          7: '1.5rem',
          8: '1.875rem',
          9: '2.25rem',
          10: '3rem',
          h1: '2.25rem',
          h2: '1.5rem',
          h3: '1.3125rem',
          h4: '1.125rem',
          h5: '0.875rem',
          h6: '0.75rem',
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
      prose: {
        family: "'Open Sans', 'Rubik', 'Helvetica', 'Arial', sans-serif",
        weight: { light: 400, regular: 400, bold: 700 },
        size: {
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
      mono: {
        family: "'Roboto Mono', monospace",
        weight: { light: 400, regular: 400, bold: 400 },
        size: {
          l: '1.25rem',
          m: '1rem',
          s: '0.875rem',
          xs: '0.8125rem',
          xxs: '0.75rem',
        },
      },
    },
    animation: {
      expressive: {
        easeOut: {
          easing: 'cubic-bezier(0, 0, 0.39, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeIn: {
          easing: 'cubic-bezier(0.4, 0.14, 1, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeInOut: {
          easing: 'cubic-bezier(0.4, 0.15, 0.3, 1)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
      },
      productive: {
        easeOut: {
          easing: 'cubic-bezier(0, 0, 0.4, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeIn: {
          easing: 'cubic-bezier(0.2, 0, 1, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
        easeInOut: {
          easing: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
          duration: {
            fastest: 100,
            fast: 200,
            medium: 400,
            slow: 550,
            slowest: 700,
          },
        },
      },
      linear: {
        easing: 'cubic-bezier(0,0,1,1)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700,
        },
      },
      delay: { fastest: 100, fast: 200, medium: 400, slow: 550, slowest: 700 },
      transition: { duration: { default: '.3s' } },
      transform: { shrink: 'scale(0.96)', grow: 'scale(1.04)' },
    },
  },
  version: '3.2.6',
};

function getTheme(key) {
  var theme = Object.assign({}, tokens[key], {
    version: tokens.version,
  });
  if (process.env.NODE_ENV === 'test') delete theme.version;
  return theme;
}
function getDefaultTheme() {
  return getTheme('default');
}
function getDarkTheme() {
  return getTheme('dark');
}

export { tokens, getTheme, getDefaultTheme, getDarkTheme };
